import { React, useState } from 'react';
import './BestInCategory.css';
import DetailsBestInCategories from './DetailsBestInCategories';
import earphone from '../../assets/BestInCate/earphone.jpeg';
import speaker from '../../assets/BestInCate/speaker.jpeg';
import watch from '../../assets/BestInCate/watch.jpeg';
import phone from '../../assets/BestInCate/phone.jpeg';
import tablet from '../../assets/BestInCate/tablet.png';

export const categories = [
  { id: 1, name: 'Smart Phones', image: phone },
  { id: 2, name: 'Smart Watch', image: watch },
  { id: 3, name: 'Wireless Speakers', image: speaker },
  { id: 6, name: 'Headphones', image: earphone },
  { id: 4, name: 'Tablets', image: tablet },
];

const BestInCategory = () => {
  const [selectedCategoryId, setSelectedCategoryId] = useState(
    categories[0]?.id
  );
  return (
    <>
      <div className="bestInCategory">
        <div className="heading">
          <h2 className="glass-heading">
            Best in <strong>Categories</strong>
          </h2>
        </div>
        <div className="category-cards">
          {categories.map((category) => (
            <div key={category.id} className="category-card">
              <div
                className={`item-circle glass-category ${
                  selectedCategoryId === category.id
                    ? 'active'
                    : ''
                }`}
                onClick={() => setSelectedCategoryId(category.id)}
              >
                <img src={category?.image} alt="bic-product" />
              </div>
              <div
                className={`text ${
                  selectedCategoryId === category.id
                    ? 'active-category-name'
                    : 'category-name'
                }`}
                onClick={() => setSelectedCategoryId(category.id)}
                style={{ cursor: 'pointer' }}
              >
                {category?.name}
              </div>
            </div>
          ))}
        </div>
      </div>

      <DetailsBestInCategories selectedCategoryId={selectedCategoryId} />
    </>
  );
};

export default BestInCategory;
